<template>
  <qx-card-form title="归属车队" v-show="userInfo && (userInfo.tenantName || userInfo.linkPhone)">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px" />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      userInfo: null,
      baseForm: {
        form: [
          {
            label: '车队名称',
            value: 'tenantName',
            type: 'input',
            disabled: true,
          },
          {
            label: '联系电话',
            value: 'linkPhone',
            type: 'select',
            disabled: true,
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    receiveData (tar, val) {
      this.userInfo = val.userInfo;
      if (this.userInfo) {
        this.$refs.baseForm.setVal('tenantName', this.userInfo.tenantName);
        this.$refs.baseForm.setVal('linkPhone', this.userInfo.linkPhone);
      }
    },

    async sub () {
      return {};
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.tip {
  margin-left: 16px;
  color: #999;
  span {
    color: #666;
    margin-right: 8px;
  }
}
</style>
